<template>
  <section id="expeditions">
    <main style="text-align: left; white-space: normal">
      <div class="title">
        <icon icoClass="title-ico" selected="expeditions" />
          {{ $t("expeditions") }}
        <router-link to="/expedition" class="btn-blue btn-small" v-if="canAdd">
          {{ $t("add_expedition") }}
        </router-link>
      </div>
      <div id="filters">
        <div v-if="canSeeFilters">
          <div class="field">
            <label>{{ $t("from") }}</label>
            <input type="date" v-model="filters.booked_date_after" @change="fillPage(1)" />
          </div>
          <div class="field">
            <label>{{ $t("to") }}</label>
            <input type="date" v-model="filters.booked_date_before" @change="fillPage(1)" />
          </div>
          <div class="field">
            <label v-if="auth.isTrw">{{ $t("delivery_note_trw") }}</label>
            <label v-if="!auth.isTrw">{{ $t("delivery_note") }}</label>
            <input type="text" v-model="filters.code" @keyup.enter="fillPage(1)" @change="fillPage(1)" />
          </div>
          <div class="field" v-if="auth.isTrw">
            <label>{{ $t("route_plate") }}</label>
            <input type="text" v-model="filters.route_plate" @keyup.enter="fillPage(1)" @change="fillPage(1)" />
          </div>
          <div class="field" v-if="auth.isTrw">
            <label>{{ $t("info_shipper") }}</label>
            <input type="text" v-model="filters.info_shipper" @keyup.enter="fillPage(1)" @change="fillPage(1)" />
          </div>
          <div class="field" >
            <label v-if="!auth.isTrw">{{ $t("client") }}</label>
            <label v-else>{{ $t("destination") }}</label>
            <search-select
              inputStyle="box-sizing: border-box"
              divStyle="text-transform: uppercase;width: 100%; box-sizing: border-box; display: inline-block"
              url="client"
              field="description"
              @data="updateClient($event); fillPage(1)"
              :source="filters.client"
              :listdata="auth.userData.clients"
            />
          </div>
          <div class="field">
            <label>{{ $t("status") }}</label>
            <span class="custom-dropdown">
              <select v-model="filters.status" @change="fillPage(1)">
                <option value=""></option>
                <option v-for="(sta, index) in filteredStatus" :key="index" :value="sta.id">
                  {{ $t(sta.description) }}
                </option>
              </select>
            </span>
          </div>
          <div class="field" v-if="companyCode === 'kl' && auth.isTrw">
            <label>{{ $t("issued") }}</label>
            <span class="custom-dropdown">
              <select v-model="showDispatched" @change="fillPage(1)">
                <option :value="false">{{ $t('not_show_issued') }}</option>
                <option :value="true">{{ $t('show_issued') }}</option>
              </select>
            </span>
          </div>
        </div>
        <date-filter
          v-if="status && status.length > 0"
          @update="$set(filters, 'booked_date_before', $event.before); $set(filters, 'booked_date_after', $event.after); fillPage(1);"
          :before="filters.booked_date_before"
          :after="filters.booked_date_after"
          :today="today"
          :options="computedOptions"
          :company="companyCode"
          @reset=" filters = {}; fillPage(1);"
        />
      </div>
      <load-screen :notFullScreen="true" v-show="loadingList"></load-screen>
      <table v-show="!loadingList" :class="['custom-table', { 'not-trw': !auth.isTrw }]">
        <thead>
          <th
            v-for="(header, index) in tableHeaders[tableOrder]"
            :key="index"
            v-if="header != 'actions' || canEdit || canAdd"
            :class="{ actions: auth.isTrw && header==='actions' }"
          >
            <span v-if="auth.isTrw && header==='k_notes_trw'">{{ $t(header, [$t(companyCode)]) }}</span>
            <span v-else>{{ $t(header) }}</span>
          </th>
        </thead>
        <tbody>
          <tr v-for="(expedition, eIndex) in objects" :key="expedition.id">
            <td v-for="(header, index) in tableHeaders[tableOrder]" :key="index" v-if="header != 'actions' || canEdit || canAdd" >
              <div v-if="header==='booked_date'">
                <span v-if="auth.isTrw">{{ expedition.booked_date | moment("D/M/YYYY") }}</span>
                <span v-else>{{ expedition.booked_date | moment('D/M/YYYY - HH:mm') }}</span>
              </div>
              <div v-if="header==='booked_time'">
                {{ expedition.booked_date | moment("HH:mm") }}
              </div>
              <div v-if="header==='loading_date'">
                <span v-if="auth.isTrw">{{ expedition.action_date | moment("D/M/YYYY") }}</span>
                <span v-else>{{ expedition.action_date | moment('D/M/YYYY - HH:mm') }}</span>
              </div>
              <div v-if="header==='loading_time'">
                {{ expedition.action_date | moment("HH:mm") }}
              </div>
              <div v-if="header==='delivery_note'">
                {{ expedition.code }}
              </div>
              <div v-if="header==='client'">
                {{ expedition.client ? expedition.client.description : '' }}
              </div>
              <div v-if="header==='destination'">
                <span v-if="auth.isTrw">{{ expedition.client ? expedition.client.description : '' }}</span>
                <span v-else>{{ expedition.destination }}</span>
              </div>
              <div v-if="header==='route_plate'">
                {{ expedition.plate }}
              </div>
              <div v-if="header==='c_notes' || header==='c_notes_trw'">
                {{ expedition.client_notes }}
              </div>
              <div v-if="header==='k_notes' || header==='k_notes_trw'">
                {{ expedition.company_notes }}
              </div>
              <div v-if="header==='shared_id'">
                {{ expedition.shared_id }}
              </div>
              <div v-if="header==='info_shipper'">
                {{ expedition.info_shipper }}
              </div>
              <div v-if="header==='pallet_notes'">
                {{ expedition.pallet_notes }}
              </div>
              <div v-if="header==='virtual_truck'">
                {{ expedition.road }}
              </div>
              <div v-if="header==='road'">
                {{ expedition.road_number }}
              </div>
              <div v-if="header==='packages'">
                {{ expedition.packages }}
              </div>
              <div v-if="header==='truck'">
                <router-link v-if="expedition.shipper && canEditTruck" :to="'/truck/' + expedition.shipper.id">
                  {{ expedition.shipper.name }}
                </router-link>
                <span v-else-if="expedition.shipper">
                  {{ expedition.shipper.name }}
                </span>
              </div>
              <div v-if="header==='arrival_date'">
                <span v-if="auth.isTrw">{{ expedition.arrival_date | moment("D/M/YYYY") }}</span>
                <span v-else>{{ expedition.arrival_date | moment('D/M/YYYY - HH:mm') }}</span>
              </div>
              <div v-if="header==='arrival_time'">
                <span>{{ expedition.arrival_date | moment("HH:mm") }}</span>
              </div>
              <div v-if="header==='status'" style="position: relative">
                <status-combo
                  :line="expedition"
                  :status="status"
                  :company="companyCode"
                  type="expedition"
                  @statusChanged="updateLineStatus(eIndex, $event.status)"
                />
              </div>
              <div v-if="header==='reason'" style="position: relative">
                <reason-combo
                  :line="expedition"
                  :reasons="reasons"
                  type="expedition"
                  @reasonChanged="updateLineReason(eIndex, $event.reason)"
                />
              </div>
              <div v-if="header==='actions'" style="padding:0; font-size:1.5em">
                <a :title="$t('attachments')" @click="openAttachments(expedition)">
                  <misc-icon icoClass="title-ico" selected="attachments" :title="$t('attachments')"/>
                </a>
                <router-link :to="'/expedition/' + expedition.id" :title="$t('detail')" v-if="canEdit">
                  <misc-icon icoClass='title-ico' selected='edit'/>
                </router-link>
                <a
                  :title="$t('send_sms')"
                  :class="{disable: locked}"
                  v-if="expedition.shipper && expedition.shipper.phone && auth.hasSms"
                  @click="line=expedition; showMessage=true;"
                >
                  <misc-icon icoClass='title-ico' selected='sms'/>
                </a>
                <a :title="$t('delete')" v-if="canDelete" @click="line=expedition; showDelete=true">
                  <misc-icon icoClass='title-ico' selected='delete' :title="$t('delete')"/>
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div id="pages">
        <div class="move-page" @click="page > 1 ? fillPage(page - 1) : ''">
          «{{ $t("prev") }}.
        </div>
        <div v-for="pageShown in pagesShown" :key="pageShown" :class="page===pageShown ? 'selected-page' : 'page'" @click="fillPage(pageShown)">
          {{ pageShown }}
        </div>
        <div class="move-page" @click="page < count / pageSize ? fillPage(page + 1) : ''">
          {{ $t("next") }}.»
        </div>
      </div>
      <modal v-show="showDelete">
        <div slot="body" class="delete-modal">
          {{ $t("delete_message") }}
          <div class="buttons">
            <button class="btn-green" @click="deleteLine(line)">{{ $t("ok") }}</button>
            <button class="btn-black" @click="showDelete=false;line=undefined;">{{ $t("cancel") }}</button>
          </div>
        </div>
      </modal>
      <modal v-show="showMessage">
        <div slot="body" class="message-modal">
          {{ $t("msg_to_send") }}
          <textarea v-model="message" cols="30" rows="4"></textarea>
          <div class="buttons">
            <button class="btn-green" @click="sendingSms({ id: line.id, basePath: 'expedition' })">{{ $t("ok") }}</button>
            <button class="btn-black" @click="showMessage=false;line=undefined;">{{ $t("cancel") }}</button>
          </div>
        </div>
      </modal>
      <modal v-if="showAttachments">
        <div slot="body">
          <attachments :title="object.date" :object="object" :canEdit="canEdit" @close="showAttachments=false" />
        </div>
      </modal>
    </main>
  </section>
</template>

<script>
import PaginatedFilteredListMixin from '@/pages/mixins/PaginatedFilteredListMixin'
import SearchSelect from './../components/SearchSelect'
import StatusCombo from './../components/StatusCombo'
import ReasonCombo from './../components/ReasonCombo'
import Attachments from './../components/Attachments'
import DateFilter from './../components/DateFilter'
import LoadScreen from './../components/LoadScreen'
import { mapActions, mapState } from 'vuex'
import Modal from './../components/Modal'
import miscIcon from './../svg/misc'
import icon from './../svg/tabs'

export default {
  name: 'expeditions',
  components: {
    SearchSelect,
    Attachments,
    StatusCombo,
    ReasonCombo,
    DateFilter,
    LoadScreen,
    miscIcon,
    Modal,
    icon
  },
  props: {},
  mixins: [ PaginatedFilteredListMixin ],
  created () {
    this.$emit('loading')
  },
  async mounted () {
    if (this.filters.hide_dispached) {
      this.showDispatched = this.filters.hide_dispached !== 'true'
    }

    await this.getExpeditionsData()
    this.fillPage(this.page)
    this.refreshTable()
  },
  beforeDestroy () {
    clearInterval(this.timer)
    clearInterval(this.refresh)
  },
  data () {
    return {
      tableHeaders: {
        defaultTrw: ['booked_date', 'booked_time', 'loading_date', 'loading_time', 'delivery_note', 'destination', 'route_plate', 'c_notes_trw', 'k_notes_trw', 'shared_id', 'info_shipper', 'pallet_notes', 'virtual_truck', 'packages', 'truck', 'arrival_date', 'arrival_time', 'status', 'reason', 'actions'],
        mexTrw: ['booked_date', 'booked_time', 'loading_date', 'loading_time', 'delivery_note', 'destination', 'route_plate', 'c_notes_trw', 'k_notes_trw', 'shared_id', 'info_shipper', 'pallet_notes', 'virtual_truck', 'packages', 'truck', 'arrival_date', 'arrival_time', 'status', 'reason', 'actions'],
        forkLiftTrw: ['booked_date', 'booked_time', 'loading_date', 'loading_time', 'delivery_note', 'destination', 'route_plate', 'c_notes_trw', 'k_notes_trw', 'shared_id', 'info_shipper', 'pallet_notes', 'virtual_truck', 'packages', 'truck', 'arrival_date', 'arrival_time', 'status', 'reason', 'actions'],
        default: ['booked_date', 'loading_date', 'delivery_note', 'client', 'destination', 'c_notes', 'k_notes', 'road', 'packages', 'truck', 'arrival_date', 'status', 'reason', 'actions'],
        mex: ['booked_date', 'loading_date', 'delivery_note', 'destination', 'c_notes', 'k_notes', 'road', 'client', 'packages', 'truck', 'arrival_date', 'status', 'reason', 'actions'],
        forkLift: ['actions', 'booked_date', 'delivery_note', 'client', 'status', 'reason', 'k_notes', 'c_notes', 'loading_date', 'destination', 'road', 'packages', 'truck', 'arrival_date'],
        kiosk: ['booked_date', 'booked_time', 'delivery_note', 'destination', 'c_notes_trw', 'k_notes_trw', 'info_shipper', 'virtual_truck', 'packages', 'truck', 'arrival_date', 'arrival_time', 'status', 'reason', 'actions'],
        bw: ['booked_date', 'booked_time', 'loading_date', 'loading_time', 'delivery_note', 'destination', 'route_plate', 'c_notes_trw', 'k_notes_trw', 'shared_id', 'info_shipper', 'pallet_notes', 'virtual_truck', 'packages', 'truck', 'arrival_date', 'arrival_time', 'status', 'actions']
      },

      companyCode: process.env.COMPANY,

      clientsMap: new Map(),
      statusMap: new Map(),
      today: new Date(),

      showAttachments: false,
      showDispatched: false,
      canSeeFilters: false,
      canEditTruck: false,
      showMessage: false,
      showDelete: false,
      canDelete: false,
      canEdit: false,
      canAdd: false,
      locked: false,

      objectFiles: [],
      objects: [],
      reasons: [],
      clients: [],
      filters: {},
      status: [],

      refresh: undefined,
      timer: undefined,
      line: undefined,

      tableOrder: 'default',
      pageSize: 10,
      message: ''
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth,

      count: state => state.expeditions.count
    }),
    filteredStatus: {
      get: function () {
        if (!this.showDispatched) return this.status.filter(x => x.description !== 'dispached')
        else return this.status
      }
    },
    pagesShown: {
      get: function () {
        var pages = [this.page]
        for (let index = 1; index <= 2; index++) {
          if (this.page - index > 0) pages.push(this.page - index)
          if (this.page + index <= Math.ceil(this.count / this.pageSize)) pages.push(this.page + index)
        }
        return pages.sort(function (a, b) { return a - b })
      }
    },
    computedOptions () {
      const options = ['yesterday', 'today', 'tomorrow']
      if (this.auth.isTrw) options.push('next_week')
      return options
    }
  },
  methods: {
    ...mapActions({
      checkPermissions: 'auth/checkPermissions',

      getObjects: 'expeditions/list',
      deleteLines: 'expeditions/delete',
      patchLine: 'expeditions/patch',
      sendSms: 'expeditions/sendSms',

      getStatus: 'status/list',
      getReasons: 'status/reasons',
      getClients: 'clients/list'
    }),
    deleteLine (line) {
      this.deleteLines(line.id).then(() => {
        this.fillPage(this.page)
        this.showDelete = false
      })
    },
    fillPage (page) {
      if (this.companyCode === 'kl' && this.auth.isTrw) {
        let hideDispached = 'false'
        if (!this.showDispatched) {
          hideDispached = !this.showDispatched ? 'true' : 'false'
        }
        this.$set(this.filters, 'hide_dispached', hideDispached)
      }
      this.$set(this.filters, 'page_size', this.pageSize)

      if (!this.filters.client) {
        this.$set(this.filters, 'client', this.auth.userData.clients)
      }

      this.getPage(page)
    },
    sendingSms (data) {
      if (data.id) {
        data.message = this.message
        this.sendSms(data).then(() => {
          this.$notify({ group: 'global', type: 'success', duration: 4000, title: 'Success', text: this.$t('message_send') })
        })
        this.showMessage = false
      }
      setTimeout(() => (this.locked = false), 10000)
    },
    updateLineStatus (index, newStatus) {
      const data = { status: newStatus.id }
      this.applyPatchLine(index, data)
    },
    updateLineReason (index, newReason) {
      const data = { reason: newReason.code }
      this.applyPatchLine(index, data)
    },
    applyPatchLine (index, data) {
      const prev = this.objects[index]
      const local = Object.assign({}, prev, data)

      // Update the status of the line
      this.patchLine({ id: local.id, ...data })
        .then((response) => {
          // update the local object with the response
          const merged = Object.assign({}, local, response || {})
          this.$set(this.objects, index, merged)
        })
        .catch((e) => {
          // revert to the previous state in case of error
          this.$set(this.objects, index, prev)
          console.error('Error updating line:', e)
          this.$notify({ group: 'global', type: 'error', duration: 4000, title: 'Error', text: this.$t('error_saving') })
        })
    },
    updateClient (value) {
      this.filters.client = value
    },
    refreshTable () {
      this.$nextTick(() => {
        this.refresh = setInterval(() => {
          // eslint-disable-next-line
          if (this.$route.name === 'expeditions') this.fillPage(this.page)
          else clearInterval(this.refresh)
        }, 60000) // one minute
      })
      this.$nextTick(() => {
        var laps = 0
        this.timer = setInterval(() => {
          laps++
          // eslint-disable-next-line
          if (this.today){
            if (this.today.getDate() !== (new Date()).getDate()) {
              this.today = new Date()
            }
          }

          if (this.$route.name !== 'expeditions') clearInterval(this.timer)
          else if (this.auth.userData.roles && this.auth.userData.roles.map((x) => { return x.id }).indexOf(this.auth.kiosk.id) > -1) {
            if (this.page + 1 <= Math.ceil(this.count / this.pageSize)) this.fillPage(++this.page)
            else this.$emit('next')
            if (laps === 100) {
              laps = 0
              location.reload()
            }
          }
        }, process.env.REFRESH_TIME * 1000)
      })
    },
    getTableOrder (permissionResponse) {
      if (this.auth.isTrw) {
        if (this.companyCode === 'bw') return 'bw'
        else if (this.auth.user === 'mexico') return 'mexTrw'
        else if (!permissionResponse.isForkLift) return 'forkLiftTrw'
        else if (!permissionResponse.isKiosk) return 'kiosk'
        else return 'defaultTrw'
      } else {
        if (this.auth.user === 'mexico') return 'mex'
        else if (!permissionResponse.isForkLift) return 'forkLift'
        else return 'default'
      }
    },
    sortStatus () {
      this.status = this.status.filter((x) => x.id !== 11 && x.id !== 4)
      const order = [998, 10, 1, 3, 2]
      this.status.sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id))
    },
    openAttachments (expedition) {
      this.object = JSON.parse(JSON.stringify(expedition))
      this.showAttachments = true
    },

    // Async methods
    async getPermissions () {
      const permissionResponse = await this.checkPermissions(['addExp', 'deleteExp', 'editExp', 'seeFilters', 'isForkLift', 'isKiosk', 'editTruck'])
      this.canAdd = permissionResponse.addExp
      this.canDelete = permissionResponse.deleteExp
      this.canEdit = permissionResponse.editExp
      this.canSeeFilters = permissionResponse.seeFilters
      this.canEditTruck = permissionResponse.editTruck
      this.tableOrder = this.getTableOrder(permissionResponse)
    },
    async getInitialData () {
      this.reasons = await this.getReasons()
      this.status = await this.getStatus('expedition')
      this.statusMap = new Map(this.status.map((x) => [x.id, x]))
    },
    async getExpeditionsData () {
      try {
        await this.getPermissions()
        await this.getInitialData()
        if (this.companyCode === 'bw') this.sortStatus()
      } catch (error) {
        console.error('Error getting expeditions:', error)
      } finally {
        this.$emit('loaded')
      }
    }
  }
}
</script>

<style scoped lang="scss">
#expeditions {
  display: table;
}
#status-box {
  position: absolute;
  top: 4em;
  left: 0;
  background: white;
  width: 100%;
  border: 1px solid #e1e1e1;
  box-sizing: border-box;
  z-index: 999;
  padding: 0.3em;
}
a {
  cursor: pointer;
}
.actions {
  width: 6%;
}
.message-modal {
  display: grid;
}
textarea {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/PageExpeditions.vue